import React, { useEffect } from "react";
import { ArrowBackIcon } from "../../../util/Icons";
import SubMenuWrapper, { SubMenuItem } from "../../../util/SubMenu";
import HalfMarathonMenu from "./HalfMarathonMenu";
import HalfMarathonPlanViewer from "../../components/HalfMarathonPlanViewer";

export default function HalfMarathonPlan() {
    useEffect(() => {
        document.title = "Half Marathon Training Plan - MCC";
    }, []);

    return (
        <div className="min-h-screen py-8 px-2 md:px-4" style={{ background: '#ffffff' }}>
            <div className="max-w-4xl mx-auto">
                {/* SubMenu */}
                <SubMenuWrapper>
                    <SubMenuItem icon={<ArrowBackIcon size={24} color="#6b7280" />} label={"Training Plans"} to={"/training-plans"} />
                </SubMenuWrapper>

                {/* Hero Section */}
                <div className="text-center mb-6 mt-4">
                    <span className="inline-block px-4 py-1 rounded-full text-sm font-medium mb-3" style={{
                        background: 'linear-gradient(90deg, #f97316 0%, #ea580c 100%)',
                        color: 'white'
                    }}>
                        🏅 HM Plan
                    </span>
                    <h1 className="text-3xl md:text-4xl font-extrabold mb-3" style={{
                        background: 'linear-gradient(90deg, #1e293b 0%, #334155 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                    }}>
                        Half Marathon Training Plan
                    </h1>
                    <p className="text-base md:text-lg" style={{ color: '#64748b' }}>
                        Train for 13 mi (21.1km) with a simple week-by-week half marathon plan.
                    </p>
                </div>

                <div className="flex flex-col p-1 text-black mx-auto space-y-4">
                    <HalfMarathonMenu />
                    <HalfMarathonPlanViewer />
                </div>
            </div>
        </div>
    );
}
